<!--
 * @Description: 注销
 * @Author: cooky
 * @Date: 2021-03-02 15:42:48
 * @LastEditors: cooky
 * @LastEditTime: 2021-03-05 17:25:27
-->
<template>
  <div class="logout">{{ $t('welcome') }}！<span @click="handleLogout">【{{ $t('logout') }}】</span></div>
</template>
<script>

export default {
  name: 'Logout',
  methods: {
    handleLogout () {
      this.$info({
        content: () => {
          return (
            <div style="text-align: left;white-space: pre-wrap;">
              {this.$t('check_logout')}
            </div>
          )
        },
        okText: this.$t('ok'),
        cancleText: this.$t('cancel'),
        onOk: () => {
          this.$store.commit('SET_TOKEN', null)
          window.sessionStorage.clear()
          this.$router.replace({
            name: 'ThirdPartChannel'
          })
        }
      })
    }
  }
}
</script>>
<style lang="less" scoped>
    .logout {
        display: inline-block;
        color: #fff;
        font-size: 20px;
        height: 38px;
        line-height: 38px;
        background-color: rgba(0,0,0,.2);
        padding: 0 28px;
        border-radius: 38px;
        span {
            color: #e8691c;
            font-weight: 500;
            cursor: pointer;
        }
    }
    @media screen and (max-width: 750px) {
       .logout {
           font-size: 2.6667rem;
           height: 5.0667rem;
           line-height: 5.0667rem;
           padding: 0 4rem;
           border-radius: 5.0667rem;
       }
    }
</style>
